module.exports = __webpack_public_path__ + "static/chemex-ad53658d229612b8d23d0307be253419.jpg";